import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const useConnect = () => {
  const { push } = useHistory();
  const [selectedBrandId, setSelectedBrandId] = useState<string>('');

  return {
    push,
    selectedBrandId,
    setSelectedBrandId,
  };
};

export default useConnect;
